import { ReactElement } from 'react';

import { useNavigation } from '@refinedev/core';

import { ArrowLeftIcon } from '@rrexpress/core';

import { BaseCard } from '../card';
import { LoadingOverlay } from '../loading-overlay/loading-overlay';

export interface IBaseEdit {
  title: string;
  children: ReactElement;
  isLoading?: boolean;
}

export const BaseEdit: React.FC<IBaseEdit> = (props: IBaseEdit) => {
  const { title, children, isLoading } = props;

  const { goBack } = useNavigation();

  return (
    <LoadingOverlay
      isLoading={!!isLoading}
      variant="circular"
      size={64}
      paddingTop={64}
    >
      <BaseCard>
        <div className="mb-8 flex font-bold items-center space-x-2">
          <div
            className="hover:text-gray-400 cursor-pointer"
            onClick={() => goBack()}
          >
            <ArrowLeftIcon />
          </div>
          <h1 className="text-xl">{title}</h1>
        </div>
        {children}
      </BaseCard>
    </LoadingOverlay>
  );
};
